<mat-toolbar
  class="mobile-navigation fixed left-0 bottom-0 !bg-white border-t border-gray-200 flex justify-between items-center"
>
  <app-menu-button class="!text-[#5a5a5a]"></app-menu-button>
  <button mat-icon-button [routerLink]="appRoutes.orders.concat('/create')">
    <mat-icon class="!text-[#5a5a5a]">edit_note</mat-icon>
  </button>
  <button mat-icon-button [routerLink]="appRoutes.dashboard">
    <mat-icon class="!text-[#5a5a5a]">dashboard</mat-icon>
  </button>

  <app-messaging-menu></app-messaging-menu>

  <app-profile-menu></app-profile-menu>
</mat-toolbar>
